export const getAriaProps = ({ error, name }: Args): ReturnType => {
  if (error)
    return {
      'aria-invalid': true,
      'aria-describedby': `${name}-error`,
    };
  return {
    'aria-invalid': false,
  };
};

type Args = {
  error: boolean;
  name: string;
};

type ReturnType =
  | {
      'aria-invalid': boolean;
      'aria-describedby': string;
    }
  | {
      'aria-invalid': boolean;
      'aria-describedby'?: undefined;
    };
